import React from 'react';
import { Card } from './ui/Card';
import { ArrowUpRight, ArrowDownRight, Minus } from 'lucide-react';
interface StatusCardProps {
  title: string;
  value: string | number;
  trend?: {
    value: number;
    label: string;
    direction: 'up' | 'down' | 'neutral';
  };
  icon?: React.ReactNode;
  color?: 'teal' | 'coral' | 'stone' | 'blue';
}
export function StatusCard({
  title,
  value,
  trend,
  icon,
  color = 'stone'
}: StatusCardProps) {
  const colors = {
    teal: 'bg-teal-50 text-teal-600',
    coral: 'bg-coral-50 text-coral-600',
    stone: 'bg-stone-100 text-stone-600',
    blue: 'bg-blue-50 text-blue-600'
  };
  return <Card data-id="element-91">
      <div className="flex items-start justify-between mb-4" data-id="element-92">
        <h3 className="text-sm font-medium text-stone-500" data-id="element-93">{title}</h3>
        {icon && <div className={`p-2 rounded-lg ${colors[color]}`} data-id="element-94">{icon}</div>}
      </div>

      <div className="flex items-baseline gap-2" data-id="element-95">
        <span className="text-3xl font-bold text-stone-900" data-id="element-96">{value}</span>
      </div>

      {trend && <div className="mt-2 flex items-center text-sm" data-id="element-97">
          {trend.direction === 'up' && <ArrowUpRight size={16} className="text-teal-600 mr-1" data-id="element-98" />}
          {trend.direction === 'down' && <ArrowDownRight size={16} className="text-coral-600 mr-1" data-id="element-99" />}
          {trend.direction === 'neutral' && <Minus size={16} className="text-stone-400 mr-1" data-id="element-100" />}

          <span className={`font-medium ${trend.direction === 'up' ? 'text-teal-600' : trend.direction === 'down' ? 'text-coral-600' : 'text-stone-500'}`} data-id="element-101">
            {trend.value}%
          </span>
          <span className="text-stone-400 ml-1" data-id="element-102">{trend.label}</span>
        </div>}
    </Card>;
}